<template>
  <div class="common">
    <search-form :formConfig="formConfig" :source="searchData" @handleSearchKlf="handleSearchKlf"
      @handleSearchZff="handleSearchZff" @handleSearchCst="handleSearchCst" @search="search">
      <template slot="btns">
        <button-load class="search-btn-item btn-blue-line" lable="融资申请" @clickHandle="submitForm"
          :disabled="selectedRows.length == 0" />
      </template>
    </search-form>

    <div class="spaceLeft input-content"></div>

    <div class="table-common">
      <a-table size="middle" :columns="columns" :row-key="record => record.id" :data-source="tableData"
        :pagination="pagination" :loading="loading" @change="handleTableChange" bordered
        :scroll="columns.length > 10 ? { x: '100%' } : {}" :locale="{ emptyText: '暂无数据' }" :row-selection="tableSelect">
        <template slot="guarantorName" slot-scope="text,record">
          <span v-if="record.guarantorName">
            {{ record.guarantorName }}
          </span>
          <span v-else>--</span>
        </template>
        <template slot="gldBal" slot-scope="text">{{ text | splitK }}</template>
        <template slot="exDay" slot-scope="text">{{
          text | dateFormat("YYYY-mm-dd")
        }}</template>
        <template slot="canBeModified" slot-scope="text">{{
          text | gbCbmTrans
        }}</template>
        <template slot="operation" slot-scope="text, record">
          <a @click="toPageDetail(record)">详情</a>
        </template>
      </a-table>
      <div :class="{
        'table-total': tableData.length > 0,
        'table-total-none': tableData.length == 0
      }">
        共有记录：
        <span class="text-color-blue">{{ pagination.total }} 条</span>祺信余额：
        <span class="text-color-orange">{{ totalPayable(tableData) | splitK }} 元</span>
      </div>
    </div>
    <goldFinancingModal ref="goldFinancingModal" :info.sync="curRow" @success="modalSuccess" />
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { selectTenant } from "@/api/login.js";
import { findGoldEstbOrRcPtyOrPypt } from "@/api/gold.js";
import { initLend, checkOriGldIsFnsing, getEstInt } from "@/api/sell.js";
import goldFinancingModal from "./gold-financing-steps/gold-financing-modal";
export default {
  props: {
    tabType: {
      type: [String],
      required: false,
      default: function () {
        return ""; //所属tab的分类
      }
    }
  },
  components: {
    goldFinancingModal
  },
  data() {
    return {
      searchData: {
        gldId: "",
        estb: {},
        pypt: {},
        exDay: [],
        tenantId: {},
        canBeModified: []
      },
      formConfig: [
        {
          prop: "gldId",
          type: "input",
          label: "祺信编号"
        },
        {
          prop: "estb",
          type: "selectSearch",
          label: "开立方",
          option: [],
          searchSource: true,
          headNameFirst: "开立方名称",
          headNameSecond: "社会信用代码",
          valuePorp: "orgCode",
          valuePorpReal: "cstId",
          labelPorp: "cstNm",
          searchHandle: "handleSearchKlf"
        },
        {
          prop: "pypt",
          type: "selectSearch",
          label: "流转方",
          option: [],
          searchSource: true,
          headNameFirst: "开立方名称",
          headNameSecond: "社会信用代码",
          valuePorp: "orgCode",
          valuePorpReal: "cstId",
          labelPorp: "cstNm",
          searchHandle: "handleSearchZff"
        },
        {
          prop: "exDay",
          type: "dateRange",
          label: "到期日期"
        },
        // {
        //     prop: "tenantId",
        //     type: "selectSearch",
        //     label: "保理商",
        //     option: [],
        //     searchSource: true,
        //     valuePorp: "tenantId",
        //     labelPorp: "tenantName",
        //     normal:true,
        //     searchHandle: "handleSearchCst",
        // },
        {
          prop: "canBeModified",
          type: "select",
          label: "变更状态",
          option: this.dict.modifiedStatus,
          mode: "multiple",
          defaultProps: {
            value: "value",
            label: "name"
          }
        }
      ],
      columns: [
        {
          title: "祺信编号",
          dataIndex: "gldId",
          sorter: true
        },
        {
          title: "开立方",
          dataIndex: "estbNm",
          sorter: true
        },
        {
          title: " 担保方",
          dataIndex: "guarantorName",
          scopedSlots: { customRender: "guarantorName" },
          sorter: true
        },
        {
          title: "流转方",
          dataIndex: "pyptNm",
          sorter: true
        },
        {
          title: "祺信余额(元)",
          dataIndex: "gldBal",
          sorter: true,
          scopedSlots: { customRender: "gldBal" }
        },
        // {
        //     title: "融资金额(元)",
        //     dataIndex: "thsFncAmt",
        //     scopedSlots: { customRender: "thsFncAmt" }
        // },
        {
          title: "到期日期",
          sorter: true,
          dataIndex: "exDay",
          scopedSlots: { customRender: "exDay" }
        },
        {
          title: "剩余天数",
          sorter: true,
          dataIndex: "residueDays"
        },
        {
          title: "变更状态",
          dataIndex: "canBeModified",
          scopedSlots: { customRender: "canBeModified" }
        },
        {
          title: "操作",
          dataIndex: "operation",
          scopedSlots: { customRender: "operation" }
        }
      ],
      tableData: [],
      pagination: {
        pageSize: 10,
        current: 1,
        sortField: "",
        sortOrder: "",
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true,
        pageSizeOptions: ["5", "10", "20", "50", "100"],
        showTotal: total => {
          return `共 ${total} 条`;
        }
      },
      loading: false,
      selectedRows: [],
      selectedRowKeys: [],
      tags: [
        { value: "0", name: "支付货款" },
        { value: "1", name: "支付工资" },
        { value: "2", name: "其他" }
      ],
      selectedTag: "",
      areaVal: "",
      recPersonInfo: {},
      recPersonList: [],
      rcvbCheckAll: "0",
      requestData: null,
      tableDataAllPage: [],
      curRow: {}
    };
  },
  computed: {
    ...mapGetters({
      userObj: "home/getUserObj"
    }),
    tableSelect() {
      return {
        type: "radio",
        selectedRowKeys: this.selectedRowKeys,
        selectedRows: this.selectedRows,
        onChange: this.onTableChange,
        getCheckboxProps: record => ({
          props: {
            disabled: record.canBeModified == "3" // Column configuration not to be checked
          }
        })
      };
    }
  },
  methods: {
    ...mapMutations({
      setFinancingDetailPrarms: "app/setFinancingDetailPrarms"
    }),
    handleSearchKlf(value, data, cfg) {
      const cstIds = this.userObj.cstIds.join(",");
      let param = {
        queryType: 1
      };
      this.getDataList(value, param, cfg);
    },
    handleSearchZff(value, data, cfg) {
      const cstIds = this.userObj.cstIds.join(",");
      let param = {
        queryType: 2
      };
      this.getDataList(value, param, cfg);
    },
    getDataList(value, param = {}, cfg) {
      //下拉筛选
      const cstIds = this.userObj.cstIds.join(",");
      findGoldEstbOrRcPtyOrPypt({
        cstNm: value,
        pageNum: 1,
        pageSize: 10,
        applyDate: "2020-09-22",
        oriGldIdNoEqual: 0,
        queryType: param.queryType || 0,
        cstIds: cstIds
      })
        .then(res => {
          const index = this.formConfig.findIndex(
            item => item.prop == cfg.prop
          );
          if (res.data && res.data.grid) {
            this.formConfig[index].option = res.data.grid.list || [];
          } else {
            this.formConfig[index].option = [];
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    handleSearchCst(value, data, cfg) {
      this.getDataListTenant(value, cfg);
    },
    getDataListTenant(value, cfg) {
      //下拉筛选
      selectTenant({
        tenantName: value,
        pageSize: 10,
        tenantName: value || "",
        pageNum: 1
      })
        .then(res => {
          const index = this.formConfig.findIndex(
            item => item.prop == cfg.prop
          );
          if (res.data && res.data.grid) {
            this.formConfig[index].option = res.data.grid.list || [];
          } else {
            this.formConfig[index].option = [];
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    search(data) {
      this.searchData = data || this.searchData;
      this.getTableData();
    },
    getTableData() {
      // 设置默认排序
      if (!this.pagination.sortField) {
        this.pagination.sortField = "exDay";
        this.pagination.sortOrder = "descend";
      }
      this.loading = true;
      const today = this.utils.dateFormat(new Date(), "yyyy-MM-dd");
      const order = this.pagination.sortOrder == "ascend" ? "asc" : "desc";
      
      // 字段映射：前端字段 -> 后端排序参数
      const sortFieldMapping = {
        'gldId': 'gldId',
        'estbNm': 'estb',
        'guarantorName': 'guarantorName',
        'pyptNm': 'pypt',
        'gldBal': 'gldBal',
        'exDay': 'exDay',
        'residueDays': 'residueDays'
      };
      
      let exDatEnOrder = "";
      let gldBalOrder = "";
      let gldIdOrder = "";
      let estbOrder = "";
      let guarantorNameOrder = "";
      let pyptOrder = "";
      
      if (this.pagination.sortField) {
        const mappedField = sortFieldMapping[this.pagination.sortField] || this.pagination.sortField;
        if (mappedField === 'exDay' || mappedField === 'residueDays') {
          exDatEnOrder = order;
        } else if (mappedField === 'gldBal') {
          gldBalOrder = order;
        } else if (mappedField === 'gldId') {
          gldIdOrder = order;
        } else if (mappedField === 'estb') {
          estbOrder = order;
        } else if (mappedField === 'guarantorName') {
          guarantorNameOrder = order;
        } else if (mappedField === 'pypt') {
          pyptOrder = order;
        }
      }
      
      const params = {
        exDatEnOrder: exDatEnOrder,
        gldBalOrder: gldBalOrder,
        gldIdOrder: gldIdOrder,
        estbOrder: estbOrder,
        guarantorNameOrder: guarantorNameOrder,
        pyptOrder: pyptOrder,
        gldId: this.searchData.gldId,
        estb: this.searchData.estb.key,
        tenantId: this.searchData.tenantId.key,
        pypt: this.searchData.pypt.key,
        rcvbExDatStart: this.searchData.exDay[0],
        rcvbExDatEnd: this.searchData.exDay[1],
        canBeModified: this.searchData.canBeModified && this.searchData.canBeModified.length > 0 ? this.searchData.canBeModified.join(",") : null,
        applyDate: today,
        oriGldIdNoEqual: 0,
        pageSize: this.pagination.pageSize,
        pageNum: this.pagination.current
      };
      initLend(params)
        .then(res => {
          this.loading = false;
          this.tableData = res.data.goldList;
          this.pagination.total = res.data.total || 0;
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
        });
      this.$store.dispatch("home/getMessageCount");
    },
    totalPayable(list, prop = "gldBal") {
      return list.reduce((acc, rec) => {
        return acc + (+rec[prop] || 0);
      }, 0);
    },
    handleTableChange(pagination, filters, sorter) {
      //表格排序回调
      this.pagination = {
        current: pagination.current,
        pageSize: pagination.pageSize,
        sortField: sorter.field,
        sortOrder: sorter.order,
        total: this.pagination.total || 0
      };
      this.getTableData();
    },
    onTableChange(selectedRows, data, data2) {
      //表格选择回调
      this.selectedRowKeys = selectedRows;
      this.selectedRows = data;
    },
    handleChangeTag(tag, checked) {
      this.selectedTag = tag.value;
    },
    getCircleList(value) {
      this.selectTenant(value);
    },
    selectTenant(value) {
      //下拉筛选
      selectTenant({
        pageSize: 10,
        tenantName: value || "",
        pageNum: 1
      })
        .then(res => {
          this.recPersonList = res.data.grid.list;
        })
        .catch(error => {
          console.log(error);
        });
    },
    submitForm(btn) {
      this.curRow = this.selectedRows[0];
      checkOriGldIsFnsing({ oriGldId: this.curRow.gldId })
        .then(res => {
          if (res.data) {
            this.$refs.goldFinancingModal.open();
          } else {
            this.$message.error("此笔祺信下存在在途融资业务，请稍后操作");
          }
          btn.closeLoad();
        })
        .catch(res => {
          btn.closeLoad();
        });
    },
    modalSuccess(data) {
      this.MENUAPI.goToOneTab({
        name: "circulation/borrow/main",
        params: data
      });
    },
    getEstInt(esPrams) {
      getEstInt(esPrams, true)
        .then(res => {
          this.feeData = res.data;
          this.setFinancingDetailPrarms({
            feeData: res.data,
            selectedRows: this.selectedRows,
            requestData: this.requestData,
            esPrams: esPrams
          });
          this.$emit("changeComp", {
            comp: "goldFinancingRequest",
            refresh: true
          });
        })
        .catch(err => {
          console.log(err);
        });
    },

    toPageDetail(data) {
      this.$emit("changeComp", {
        comp: "financingGoldDetailComp",
        refresh: true,
        data: {
          way: "seller",
          gldId: data.gldId,
          fromType: 5,
          goldObj: data
        }
      });
    }
  },
  created() {
    this.getTableData();
  },
  mounted() { },
  activated() { }
};
</script>
<style scoped>
.input-content {
  background: #fff;
}

.input-content>div {
  margin: 16px 16px 16px 16px;
}
</style>



// WEBPACK FOOTER //
// src/pages/circulation/gold-financing/gold-financing-main.vue